<template>
  <route_generate>
   <div class="animated fadeIn">
    <b-row>
     <b-col sm="12">
      <b-card header-tag="header" footer-tag="footer">
       <div slot="header">
        <strong>Generate Route</strong>
       </div>
      
       <b-card v-if="vehicleAcceptedLoads.length>0">
        <b-list-group flush>
          
         <b-list-group-item v-for="(vehicle,index) in vehicleAcceptedLoads" :key="index" style="box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px;">
          
          <b-row>
           <b-col sm="10">
            <!-- Accordion button - Will not be triggered when checkbox is clicked -->
            <b-button variant="primary" class="w-100 text-left" @click="toggleCollapse(index, vehicle)">
             <b-row>
              <b-col sm="2" class="bordered-col" title="Vehicle No." style="font-size:14px">Vehicle No: {{ vehicle.vehicle_no }}</b-col>
              <b-col sm="2" class="bordered-col" title="Planning Date." style="font-size:14px">Planning Date: {{ vehicle.created_date }}</b-col>
              <b-col sm="2" class="bordered-col" title="Transporter Name." style="font-size:14px">Transporter: {{ vehicle.transporter_name }}</b-col>
              <b-col sm="2" class="bordered-col" title="Vehicle Type." style="font-size:14px">Vehicle Type: {{ vehicle.actual_vehicle_type }}</b-col>
              <b-col sm="1" class="bordered-col" title="Capacity" style="font-size:14px">Capacity: {{ vehicle.vehiclecapacity }}</b-col>
              <b-col sm="1" class="bordered-col" title="Occupied" style="font-size:14px">Occupied: {{ vehicle.occupied?vehicle.occupied:vehicle.occupied }}</b-col>
              <b-col sm="1" class="bordered-col" title="Space" style="font-size:14px">Space: {{ vehicle.space }}</b-col>
              <b-col sm="1" class="bordered-col" title="Vehicle Type" style="font-size:14px">Type: {{vehicle.vehicle_type}}</b-col>
             </b-row>
            </b-button>
           </b-col>
           <b-col sm="2" class="text-left" style="margin:auto 0">
            <b-button :disabled="vehicle.editable_flag=='yes'" variant="primary" @click="getMapData(vehicle,index)">Map{{ index+1 }}</b-button>&nbsp; <b-button variant="success" title="Temporary Freeze" :disabled="vehicle.editable_flag=='yes' || isReadOnly" @click="onFreezeClick(vehicle,index)"> Freeze</b-button>
           </b-col>
          </b-row>
          <b-collapse @hide="vehicleDrawerClose" :visible="activeCollapseRoute === index" :id="'collapse-' + index">
           <br>
           <b-row>
            <b-col sm="6" v-if="vehicle.only_loads.length>0" class="text-left">
             <input type='checkbox' @click="checkAllLoad(vehicle.only_loads)" v-model='isCheckAllLoad'>
             <span> Select All </span>
            </b-col>
            <b-col :sm="vehicle.only_loads.length>0?'6':'12'" class="text-right">
             <p>
              <b>Total Records : <span style="color:red;">{{ vehicle.only_loads.length }}</span>
              </b>
             </p>
            </b-col>
           </b-row>
           <b-row>
            <b-col sm="12">
             <b-table show-empty responsive :items="vehicle.only_loads" :fields="loadfields" :bordered="bordered" :outlined="outlined" :busy="isBusy" :tbody-tr-class="rowClass">
              <div slot="table-busy" class="text-center text-danger my-2">
               <b-spinner class="align-middle"></b-spinner>
               <strong>Loading...</strong>
              </div>
              <template slot="select" slot-scope="row">
               <b-form-group>
                <input class="AWBcheckbox" type="checkbox" v-bind:value="row.item.parentawb" @change="checkRandomAWBNew($event,vehicle.only_loads)" v-model='checkedAWB' />
               </b-form-group>
              </template>
              <template slot="action" slot-scope="row" :class="{'highlight-row': row.item.sequenceno === null}">
               <div v-if="sequenceIndex === row.item.sequenceno">
                <b-form-input v-model="tempIndex" placeholder="Enter your name"></b-form-input>
                <b-button size="sm" @click="saveEdit(vehicle.only_loads,index,row.index,row.item.unikey)">Save</b-button>
                <b-button size="sm" @click="cancelEdit">Cancel</b-button>
               </div>
               <div v-else>
                <b-button size="sm" @click="editRow(row.item.sequenceno,vehicle,row.item.unikey)" class="mr-2" :disabled="isReadOnly">
                 <i class="fa fa-pencil-square-o"></i> {{ row.item.sequenceno}}
                </b-button>
               </div>
              </template>
             </b-table>
            </b-col>
           </b-row>
           <br>
           <b-row>
            <b-col :sm="checkedAWB.length>0?'6':'12'" class="text-left">
             <b-button v-if="checkedAWB.length" variant="danger" @click="removeLoadFromListing(vehicle.only_loads,index)" size=sm>Remove Load</b-button>
            </b-col>
            <b-col :sm="checkedAWB.length>0?'6':'12'" class="text-right">
             <b-button v-if="vehicle.only_loads.length>0" variant="primary" @click="submitFinal(vehicle.destination_sequence,index)" :disabled="isReadOnly" size=sm>Change Sequence</b-button>
            </b-col>
           </b-row>
           <br>
          </b-collapse>
         </b-list-group-item>
        </b-list-group>
       </b-card>
      </b-card>
      <!-- City Map -->
      <b-modal title="Map" @ok="showCityMap=false" v-model="showCityMap" hide-footer size="xl" @shown="initMapLoad">
       <b-row>
        <b-col md="3">
         <b-card class="mb-2 pending_remove">
          <b-card-text>
           <div style="max-height: 500px; overflow-y: scroll;">
            <h5 style="text-align: center;">Pending Loads</h5>
            <b-list-group v-for="items in pendingLaods" :key="items.loadid">
             <b-list-group-item>
              <span :title="'Address:'+items.address+' - '+'userid:'+items.userid">{{items.loadid}}</span>&nbsp; <b-button variant="outline-primary" :title="'Add Loads -'+'Address:'+items.address+' - '+'userid:'+items.userid" @click="addLoad(items)" :disabled="isReadOnly">
               <i class="fa fa-plus-circle" aria-hidden="true"></i>
              </b-button>
             </b-list-group-item>
            </b-list-group>
           </div>
          </b-card-text>
         </b-card>
        </b-col>
        <b-col md="9">
         <b-card class="mb-2">
          <b-card-text>
           <b-col v-if="totalDistanceTravel" md="12" class="text-right">
            <b>Total Duration :- </b>
            <span style="color:red">
             <b>{{ totalDuration }} Hrs </b>
            </span>
            <b>Total Distance :- </b>
            <span style="color:red">
             <b>{{ totalDistanceTravel }} KM </b>
            </span>
           </b-col>
           <div id="map" style="height: 500px;"></div>
           <b-modal v-model="showModal" hide-footer title="Map Loads" size="xl">
            <b-row>
             <b-col sm="6" v-if="pincodeWiseLoad.length>0">
              <input type='checkbox' @click="checkAll()" v-model='isCheckAll'>
              <span> Select All </span>
             </b-col>
             <b-col :sm="pincodeWiseLoad.length>0?'6':'12'" class="text-right">
              <p>
               <b>Total Records : <span style="color:red;">{{ pincodeWiseLoad.length }}</span>
               </b>
              </p>
             </b-col>
            </b-row>
            <b-row>
             <b-col sm="12">
              <b-table show-empty responsive stacked="md" :items="pincodeWiseLoad" :fields="fields" :current-page="currentPage" :per-page="perPage" :filter="filter" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection" @filtered="onFiltered" :bordered="bordered" :outlined="outlined" :busy="isBusy">
               <div slot="table-busy" class="text-center text-danger my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong>Loading...</strong>
               </div>
               <template slot="select" slot-scope="row">
                <b-form-group>
                 <input class="parentAWBcheckbox" type="checkbox" v-bind:value="row.item.parentawb" @change="checkRandomAWB($event,pincodeWiseLoad)" v-model='checkedParentAWB' />
                </b-form-group>
               </template>
              </b-table>
             </b-col>
            </b-row>
            <b-row>
             <b-col sm="6">
              <b-button v-if="checkedParentAWB.length && isReadOnly==false" @click="removeloads()" variant="success" size=sm>Remove Load</b-button>
             </b-col>
             <b-col :sm="checkedParentAWB.length>0?'6':'12'" class="text-right">
              <b-button variant="danger" @click="closeModal()">Close</b-button>
             </b-col>
            </b-row>
           </b-modal>
          </b-card-text>
         </b-card>
        </b-col>
       </b-row>
      </b-modal>
      <!-- City Map -->
     </b-col>
    </b-row>
   </div>
  </route_generate>
 </template>
<script>
  //  import DirectionsRenderer from "./DirectionsRenderer";
   import spinner from './Loader/spinner.vue';
  //  import customMarker from "./customMarker.vue";
  import CONSTANTS from "@/utils/constants";
  import Utils from "@/utils";
  import Vue from "vue";
  export default {
 
    data() {
      return {
        vehicleAcceptedLoads: [],
        vehicleRejectedLoads: [],
        center: {
          lat: 0,
          lng: 0
        },
       
        available_vehiclelist: [],
        available_list: '',
        
        optionsHub: [],
        HubData: [],
        valueVehicle: [],
        optionsVehicle: [],
        vehicleData:[],
        fieldVehicle: {
          text: 'name',
          value: 'id'
        },
       
        vehicleLoads:[],
        pendingLaods:[],
         
        showCityMap:false,
        waypoints : [],
        sourceLatLng : [],
      
        Loadmap:null,
        directionsRenderers:null,
        directionsService:null,
        showloadtypedetails:false,
       
        LoadmapWise:null,
        waypointsWise:[],
        directionsRenderer:null,
       
        cityWiseLatLng:[],
        sourceLatLngLoadWise:[],
        customModal:false,
        modalMessage:"",
        showModal:false,
        dest_pincode:[],
        pincodeWiseLoad:[],
        fields:[
          { key: 'select', label: 'Select', sortable: true, sortDirection: 'desc' },
          { key: 'parentawb', label: 'Parent AWB', sortable: true, sortDirection: 'desc' },
          { key: 'loadid', label: 'Load id', sortable: true},
          { key: 'userid', label: 'User ID', sortable: true},
          { key: 'noofboxes', label: 'No of boxes', sortable: true},
          
           { key: 'shipmentvolumetricweight', label: 'Volumetric Weight', sortable: true},  
          { key: 'dest_state', label: 'Destination State', sortable: true },
          { key: 'dest_city', label: 'Destination City', sortable: true },
         
          { key: 'destinationpincode', label: 'Destination Pincode', sortable: true },
          { key: 'loadpotype', label: 'Load PO Type', sortable: true },
          // { key: 'action', label: 'Action', sortable: true },
          
        ],
        viewfields:[
          { key: 'select', label: 'Select', sortable: true, sortDirection: 'desc' },
          { key: 'parentawb', label: 'Parent AWB', sortable: true, sortDirection: 'desc' },
          { key: 'loadid', label: 'Load id', sortable: true},
          { key: 'userid', label: 'User ID', sortable: true},
          { key: 'noofboxes', label: 'No of boxes', sortable: true},
          { key: 'shipmentvolumetricweight', label: 'Volumetric Weight', sortable: true},  
          { key: 'dest_state', label: 'Destination State', sortable: true },
          { key: 'dest_city', label: 'Destination City', sortable: true },
        
          { key: 'destinationpincode', label: 'Destination Pincode', sortable: true },
          { key: 'loadpotype', label: 'Load PO Type', sortable: true },
          // { key: 'action', label: 'Action', sortable: true },  
        ],
        isBusy: false,
        
        
        selectLoad :[],
        mapIndex:null,
        spinnerFlag:false,
        totalDistanceTravel:0,
        totalDuration:0,
        generate_route_Link:'',
        tempIndex: null,
        sequenceIndex:null,
        sequenceLength:null,
        emptySequense:false,
        checkedParentAWB:[],
        removeObj:[],
        rowIndex:null,
        isCheckAll:false,
        activeCollapseRoute:null,
        accessBody:[],
        isReadOnly:false,
        loadfields:[
          { key: 'select', label: 'Select', sortable: true, sortDirection: 'desc' },
          { key: 'userid', label: 'User Id', sortable: true, sortDirection: 'desc' },
          { key: 'loadid', label: 'Load id', sortable: true},
          { key: 'noofboxes', label: 'No of Boxes', sortable: true},
          { key: 'loadpotype', label: 'Load PO Type', sortable: true },
          { key: 'hub_city', label: 'WH/HUB', sortable: true},
          { key: 'shipmentvolumetricweight', label: 'Vol. Wt', sortable: true}, 
          { key: 'shippincode', label: 'Ship Pincode', sortable: true},   
          { key: 'parentawb', label: 'AWB', sortable: true},   
          { key: 'destinationcompanyname', label: 'Company Name', sortable: true},
          { key: 'origin_city', label: 'City', sortable: true },
          { key: 'zone_title', label: 'Hub Zone', sortable: true },
          { key: 'dest_city', label: 'Dest City', sortable: true },
          { key: 'dest_state', label: 'Dest State', sortable: true },
          { key: 'zoneinscandate', label: 'Zone Inscan', sortable: true },
          { key: 'shipoutdate_time', label: 'shipout', sortable: true },
          { key: 'destinationaddress', label: 'Address', sortable: true },
          { key: 'action', label: 'Sequence', sortable: true },  
        ],
        isCheckAllLoad:false,
        checkedAWB:[],
      };
    },
    components: {
      spinner,
    },
    props:['selectedHub'],
    created() {
      var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);
      this.userType = userInfo.user_type;
      this.Usersysuser = userInfo.sysusermasterid;
      this.user_id = userInfo.sysusermasterid;
      this.accessBody = userInfo.body;
      this.ischeckbodyvalidation();
      this.showVehiclelist(this.selectedHub);
      this.activeCollapseRoute = null;
       const storedactiveCollapseRoute = localStorage.getItem("activeCollapseRoute");
        if (storedactiveCollapseRoute) {
            this.activeCollapseRoute = storedactiveCollapseRoute;
        }
     
    },
    watch: {
      selectedHub() {
            if (this.selectedHub=='' || this.selectedHub==null || this.selectedHub== undefined || this.selectedHub=='null') {
               
                this.selectedHub=''; 
               this.clear()
            }
            else{
                this.vehicleAcceptedLoads=[];
                this.showVehiclelist(this.selectedHub);
               
            }
        }
    },
    methods: {
      ischeckbodyvalidation(){
            for (let i = 0; i < this.accessBody.length; i++) {
                const element = this.accessBody[i];
            
                // if (element.title=="Route History" && element.isReadonly==true && this.route_id=='normal') {
                //   this.isReadOnly=true
                // }
            if (element.child) {
                for (let j = 0; j < element.child.length; j++) {
                const k = element.child[j];
                if (k.title=="Route History" && k.isReadonly==true) {
                    this.isReadOnly=true
                }
                }
            }
            }
        },

      getMapData(vehicle,index){
       
        this.mapIndex=null;    
        this.mapIndex=index;
        let vehicleDetails=localStorage.getItem('vehicleDetails')
        let vehicleData= JSON.parse(vehicleDetails);
      
        this.dest_pincode=vehicleData[index].destination_sequence;
        localStorage.setItem('destination_sequence',JSON.stringify(this.dest_pincode));
       
        let waypoints = vehicleData[index].destination_sequence;
      
        this.waypoints=waypoints.map(item=>({
          "lat": parseFloat(item.latlong.x),
          "lng": parseFloat(item.latlong.y),
          "pincode":item.pincode,
          "unikey":item.unikey
        }))
        
        this.showCityMap=true;

      },
      
   
 
      initMapLoad() {
        this.isCheckAll=false;
        this.Loadmap = new google.maps.Map(document.getElementById('map'), {
            center: { lat: 12.971598, lng: 77.594562 },
            zoom: 10,
        });

        this.directionsService = new google.maps.DirectionsService();
        this.directionsRenderers = new google.maps.DirectionsRenderer({
            map: this.Loadmap,
            suppressMarkers: true,
            polylineOptions: {
                strokeColor: 'blue',
                strokeWeight: 4
            }
        });

        const waypointsLatLng = this.waypoints.map(waypoint => new google.maps.LatLng(waypoint.lat, waypoint.lng));
        
        const request = {
            origin: waypointsLatLng[0],
            destination: waypointsLatLng[waypointsLatLng.length - 1],
            waypoints: this.waypoints.slice(1, -1).map(waypoint => ({
                location: new google.maps.LatLng(waypoint.lat, waypoint.lng),
                stopover: true
            })),
            travelMode: google.maps.TravelMode.DRIVING,
        };
        
        this.totalDistanceTravel = 0;
        this.totalDuration=0;
        this.directionsService.route(request, (response, status) => {
            if (status === 'OK') {
                this.directionsRenderers.setDirections(response);

                const legs = response.routes[0].legs;
                let sum = 0;
                let durations=0;
                legs.forEach((leg, index) => {
                
                if (this.waypoints[index + 1]) { // Check if the next waypoint exists
                   
                    const distance = `From ${this.waypoints[index].pincode} to ${this.waypoints[index + 1].pincode} distance ${leg.distance.text}`;
                    sum += parseFloat(leg.distance.text.replace(/[^\d.-]/g, ''));
                    durations += parseFloat(leg.duration.text.replace(/[^\d.-]/g, ''));
                    const marker = this.markers[index + 1];
                    if (marker) {
                        marker.setTitle(distance);
                    }
                } else {
                    console.log("No more waypoints to process.");
                }
            });
            this.totalDistanceTravel=sum.toFixed(2);
            this.totalDuration=(durations/60).toFixed(2);
            
            } else {
                window.alert('Directions request failed due to ' + status);
            }
        });

        // Create markers for each waypoint
        this.markers = [];
        this.waypoints.forEach((waypoint, index) => {
          
            const labelChar = String.fromCharCode(65 + index); // 65 is the ASCII code for 'A'

            const marker = new google.maps.Marker({
                position: new google.maps.LatLng(waypoint.lat, waypoint.lng),
                map: this.Loadmap,
                icon: {
                    path: google.maps.SymbolPath.CIRCLE,
                    scale: 10, // Adjust scale to cover the icon circle
                    fillColor: index === 0 ? 'green' :
                        (index === this.waypoints.length - 1 ? 'red' : 'yellow'),
                    fillOpacity: 1,
                    strokeColor: 'black',
                    strokeWeight: 1,
                    labelOrigin: new google.maps.Point(0, 0) // Adjust to position the label correctly
                },
                title: `Start Point - ${waypoint.pincode}`, // Initial title
                label: {
                    text: labelChar,
                    color: 'black', // Ensure this is visible against the icon color
                    fontSize: '16px', // Increase the size to cover the icon circle
                    // fontWeight: 'bold',
                }
            });

            this.markers.push(marker);
           
            if (index > 0) {
                marker.addListener("click", () => {
                    this.pincodeWiseLoad = [];
                    let vehicleDetails = localStorage.getItem('vehicleDetails');
                    let vehicleData = JSON.parse(vehicleDetails);
                    let loads = vehicleData[this.mapIndex].loads;
                    let clicked_pincode = this.waypoints[index].pincode;

                    this.pincodeWiseLoad = loads.filter(item => item.destinationpincode === clicked_pincode);
                    this.isCheckAll = false;
                    this.showModal = true;
                    
                });
            }
        });
    },


    closeModal() {
          this.showModal = false;
          
          this.checkedParentAWB=[];
          // this.isCheckAll =;
        },

     // Load Map End
      getRoute() {
        document.getElementById("overlay").style.display = "block";
        var userdata = localStorage.getItem("userData");
        var userInfo = JSON.parse(userdata);
        if(this.selectedHub!=''){
          let getHubName =this.selectedHub.label.split('-');
          let trimSpace=getHubName[1].trim();
         
        const obj = {
          hubid:this.selectedHub.key,
          availablevehicles:this.available_vehiclelist,
          city:`${trimSpace}`
        };
       
        this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/finalSetRouteApiPro145`, obj).then((result) =>{
          document.getElementById("overlay").style.display = "none";
          
          if (result.body.returnmsg === "Successful") {
           
            this.vehicleAcceptedLoads = result.body.returnvalue;
            // console.log("this.vehicleAcceptedLoad------------->",this.vehicleAcceptedLoads);
            let vehicleDetails=result.body.returnvalue;
            localStorage.setItem('vehicleDetails', JSON.stringify(vehicleDetails));
            this.pendingLaods=result.body.pendingloads;
            localStorage.setItem('pendingLoads', JSON.stringify(this.pendingLaods));
            
            this.totalvehiclelist= this.vehicleAcceptedLoads.length;
          } else {
            this.available_vehiclelist = [];
            this.pendingLaods = [];
            this.totalvehiclelist = 0;
            this.$fire({
              text: result.body.returnvalue,
              type: "error",
              timer: 30000,
            });
          }
        }).catch((ex) => {
          console.log("error", ex);
        });
        }else{
          // this.$fire({
          //   text: "Please Select Hub",
          //   type: "warning",
          //   timer: 30000,
          // });
          document.getElementById("overlay").style.display = "none";
          return false;
        }
        
      },
      clear: function() {
        this.available_list='',
        this.totalvehiclelist = 0;
        this.selectedHub='';
        this.vehicleAcceptedLoads = [];
        this.pendingLaods=[];
        this.checkedAWB=[];
        this.checkedParentAWB=[];
        this.isCheckAll = false;
        this.isCheckAllLoad=false;
        localStorage.setItem('destination_sequence', '');
        localStorage.setItem('loads', '');
        localStorage.setItem('vehicleDetails', '');
        localStorage.setItem('pendingLoads', '')
      },

      
     
      showWHlist: function() {
        var userdata = localStorage.getItem('userData')
        var userInfo = JSON.parse(userdata)
        var csvObj = {
          sysusermasterid:`${userInfo.sysusermasterid}`,
          usertype:`${userInfo.user_type}`
        };
     
        // return false;
        this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getAllHubListing`, csvObj).then(result => {
          if (result.body.returnmsg === 'Successful') {
            this.optionsHub = [];
            this.HubData = result.body.returnvalue;
            var data = [];
            this.HubData.forEach(function(srData) {
              data.push({
                key: srData.hubid,
                label: srData.hubid + " - " + srData.hubname
              });
            });
            this.optionsHub = data;
          } else {
            this.HubData = [];
          }
        }).catch(ex => {
          console.log("error-----", ex);
        });
      },
      updateSelect(){
       this.vehicleAcceptedLoads=[];
      },
      showVehiclelist: function(hubId) {
       
        var userdata = localStorage.getItem('userData')
        var userInfo = JSON.parse(userdata)
        if(this.selectedHub!=""){
          var csvObj = {
          hubid:this.selectedHub?`${this.selectedHub.key}`:null,
          
        }
      
        this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getAvailableVehicleForWarehouseRoutePlanning`, csvObj).then(result => {
          if (result.body.returnmsg === 'Successful') {
            this.optionsVehicle = [];
            this.available_vehiclelist = result.body.returnvalue;
            var vehicleNos = "";
           
            for (let j = 0; j < this.available_vehiclelist.length; j++) {
              let vehicle = {
                name: this.available_vehiclelist[j].vehicle_id + " - " + this.available_vehiclelist[j].vehicle_no,
                id: this.available_vehiclelist[j].vehicle_id,
              }
            
              this.optionsVehicle.push(vehicle);
              
              if (j > 0) {
                  vehicleNos += ",";
                }
                vehicleNos += this.available_vehiclelist[j].vehicle_no;
            
            }
            
              this.available_list=vehicleNos;
              this.getRoute();
          } else {
            this.available_vehiclelist = [];
            this.available_list='';
            this.$fire({
              text: result.body.returnvalue,
              type: "error",
              timer: 30000,
            });
          }
        }).catch(ex => {
          console.log("error-----", ex);
        });
          
        }else{
          // this.$fire({
          //     text: "Please Select Hub",
          //     type: "warning",
          //     timer: 30000,
          //   });
            document.getElementById("overlay").style.display = "none";
            return false;
        }
       
      },
       
      removeloads(){
          let items; // Get the array of checked items (which are objects)
          let loadsArr=[];
          if(this.pincodeWiseLoad.length==this.checkedParentAWB.length){
            items=this.pincodeWiseLoad;
          }else{
            loadsArr = this.pincodeWiseLoad.filter(element => this.checkedParentAWB.includes(element.parentawb));
          }
          if(this.pincodeWiseLoad.length!=this.checkedParentAWB.length){
            items=loadsArr
          }

          // Load vehicle and pending load data from localStorage
          let vehicleDetails = localStorage.getItem('vehicleDetails');
          let vehicleData = JSON.parse(vehicleDetails);

          let pendingLaodData = localStorage.getItem('pendingLoads');
          let pendingLoadInfo = JSON.parse(pendingLaodData);
          if(vehicleData[this.mapIndex].addremove_restrictflag=='yes'){
            this.$fire({
                text: `Sequence Changed Can't Remove Load`,
                type: "error",
                timer: 30000,
              });
            return false
          }else{
            // Process each item in the checkedParentAWB array
            items.forEach((item,index) => {
                let popItem = item; // Each item is already an object in checkedParentAWB
                pendingLoadInfo.push(popItem); // Add the item to the pendingLoads array
                this.pendingLaods = pendingLoadInfo;

                localStorage.setItem('pendingLoads', JSON.stringify(pendingLoadInfo));
                let all_Loads = vehicleData[this.mapIndex].loads;

                // Find and remove the item from the all_Loads array
                let indexToRemove = all_Loads.findIndex(obj => obj.loadid === popItem.loadid);
                if (indexToRemove !== -1) {
                    all_Loads.splice(indexToRemove, 1);
                }

                // Update the vehicle's loads in vehicleData
                vehicleData[this.mapIndex].loads = all_Loads;
                
                // Recalculate waypoints
                let waypoints = vehicleData[this.mapIndex].destination_sequence;
                this.waypoints = waypoints.map(waypoint => ({
                    "lat": parseFloat(waypoint.latlong.x),
                    "lng": parseFloat(waypoint.latlong.y),
                    "pincode": waypoint.pincode
                }));

                localStorage.setItem('vehicleDetails', JSON.stringify(vehicleData));
            });
            this.showModal = false;
            this.isCheckAll = false;
            this.addOrRemoveLoads();
          }
      },
      
      addOrRemoveLoads(){
        document.getElementById("overlay").style.display = "block";
        let vehicleDetails=localStorage.getItem('vehicleDetails')
        let vehicleData= JSON.parse(vehicleDetails);
       
        let removeAddObj=vehicleData[this.mapIndex];
        // return false
        this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/addOrRemoveLoadsAndSequelizepro145`, removeAddObj).then(result => {
          
          document.getElementById("overlay").style.display = "none";
          if (result.body.returnmsg === "Successful") {
          
            vehicleData[this.mapIndex]=result.body.returnvalue[0];
            
            this.vehicleAcceptedLoads = vehicleData;
            this.dest_pincode=vehicleData[this.mapIndex].destination_sequence;
            localStorage.setItem('destination_sequence',JSON.stringify(this.dest_pincode));
        
           let waypoints = vehicleData[this.mapIndex].destination_sequence;
          
            this.waypoints=waypoints.map(item=>({
              "lat": parseFloat(item.latlong.x),
              "lng": parseFloat(item.latlong.y),
              "pincode":item.pincode
            }))
            
            localStorage.setItem('vehicleDetails', JSON.stringify(vehicleData)); 
            this.totalvehiclelist= this.vehicleAcceptedLoads.length;
            this.checkedParentAWB=[];
            // if(remove_from=='from_map'){
              this.Loadmap=null;
              this.initMapLoad();
            // }
            
           
          } else {
            this.available_vehiclelist = [];
            this.pendingLaods = [];
            this.totalvehiclelist = 0;
            this.$fire({
              text: result.body.returnvalue,
              type: "error",
              timer: 30000,
            });
          }
          
        })

      },
      addLoad(items){ 
        let vehicleDetails=localStorage.getItem('vehicleDetails')
        let vehicleData= JSON.parse(vehicleDetails);
        if(vehicleData[this.mapIndex].addremove_restrictflag=='yes'){
            this.$fire({
                text: `Sequence Changed Can't Add Load`,
                type: "error",
                timer: 30000,
              });
              return false
        }else{
          vehicleData[this.mapIndex].loads.push(items);
          let removeAddObj=vehicleData[this.mapIndex];
          
          this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/addOrRemoveLoadsAndSequelizepro145`, removeAddObj).then(result => {
            
            if (result.body.returnmsg === "Successful") {
            
              let pendingLaodData = localStorage.getItem('pendingLoads')
              let pendingLoadInfo = JSON.parse(pendingLaodData);
              pendingLoadInfo = pendingLoadInfo.filter(load => load.loadid !== items.loadid);
        
              this.pendingLaods=pendingLoadInfo;
              localStorage.setItem('pendingLoads',JSON.stringify(pendingLoadInfo));
              vehicleData[this.mapIndex]=result.body.returnvalue[0];
              
              this.vehicleAcceptedLoads = vehicleData;
              this.dest_pincode=vehicleData[this.mapIndex].destination_sequence;
              localStorage.setItem('destination_sequence',JSON.stringify(this.dest_pincode));
            
              let waypoints = vehicleData[this.mapIndex].destination_sequence;
              
                this.waypoints=waypoints.map(item=>({
                  "lat": parseFloat(item.latlong.x),
                  "lng": parseFloat(item.latlong.y),
                  "pincode":item.pincode
                }))
              
                localStorage.setItem('vehicleDetails', JSON.stringify(vehicleData));
              
                
                this.totalvehiclelist= this.vehicleAcceptedLoads.length;
                this.Loadmap=null;
                this.initMapLoad();
            
            } else {
            
              this.$fire({
                text: result.body.returnvalue,
                type: "error",
                timer: 30000,
              });
            }
            
          })
        }
      },
      GenerateRoute(index){
        this.mapIndex=null;
        this.mapIndex=index;
        let vehicleDetails=localStorage.getItem('vehicleDetails')
        let vehicleData= JSON.parse(vehicleDetails);

        let generateObj=vehicleData[this.mapIndex];
       
        this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getFinalSetRouteVehicleCSVPath`, generateObj).then(result => {
         
          if (result.body.returnmsg === "Successful") {
            const generate_route_Link = result.body.returnvalue;
          
            const a = document.createElement('a');
            a.style.display = 'none';
            document.body.appendChild(a);
            a.href = generate_route_Link;
            a.download = `Vehicle_No-${generateObj.vehicle_no}Load_file.csv`;
            a.click();
           
            this.getRoute();
           
          } else {
            this.$fire({
              text: result.body.returnvalue,
              type: "error",
              timer: 30000,
            });
          }
          
        })
      },
      onFreezeClick(vehicle,index) {
        if(vehicle.loads.length>0){
          document.getElementById("overlay").style.display = "block";
          var userdata = localStorage.getItem("userData");
          var userInfo = JSON.parse(userdata);
          vehicle.hubid=`${this.selectedHub.key}`;
          vehicle.lastmodifiedby=`${userInfo.userfirstname} ${userInfo.userlastname}`
          let freezeObj=vehicle;
          this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/apiToFreezeTheVehicleForRouting`, freezeObj).then(result => {
            document.getElementById("overlay").style.display = "none";
            if (result.body.returnmsg === "Successful") {
              
              this.$fire({
                text: 'Successful',
                type: "success",
                timer: 30000,
              });
              this.$emit('freeze-clicked');
            
            } else {
              this.$fire({
                text: result.body.returnvalue,
                type: "error",
                timer: 30000,
              });
            }
          })
        }else{
          this.$fire({
                text: `Vehicle can't be empty.Please add Load`,
                type: "warning",
                timer: 30000,
              });
        }
       
      },
      submitFinal(destination,index){
        this.emptySequense=false;
        let pincodeSqEmpty=[];
        document.getElementById("overlay").style.display = "block";
        for(let i=0;i<destination.length;i++){
           if(destination[i].sequenceno==null){
            this.emptySequense=true;
            pincodeSqEmpty.push(destination[i].unikey)
           }
        }
        if(this.emptySequense==true){
          document.getElementById("overlay").style.display = "none";
            this.$fire({
            text: `This Pincode ${pincodeSqEmpty} Sequence is Empty`,
            type: "error",
            timer: 30000,
          });
        }else{
          let vehicleDetails=localStorage.getItem('vehicleDetails')
          let vehicleData= JSON.parse(vehicleDetails);
          
          // return
          this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/editSetRoutePro145`, vehicleData[index]).then(response => {
            document.getElementById("overlay").style.display = "none";
          if(response.body.returnmsg=='Successful'){
             
              let result=response.body.returnvalue;
              vehicleData[index]=result
              
              this.vehicleAcceptedLoads=vehicleData;
              
              localStorage.setItem('vehicleDetails', JSON.stringify(vehicleData));
             
            }else{
              this.$fire({
                text: result.body.returnvalue,
                type: "error",
                timer: 30000,
              });
            }
          })
        }
      },

      editRow(pincodeIndex,vehicle,unikey) {
        this.sequenceLength=0;
        this.sequenceIndex=pincodeIndex;
        this.tempIndex=pincodeIndex;
        let key=[]
        for(let item of vehicle.only_loads){
          key.push(item.unikey)
        }
        let uniqueElement = new Set(key)
        this.sequenceLength=uniqueElement.size;
        
      },

      saveEdit(pincode, index,pincodeindex,unikey) {
        let vehicleDetails=localStorage.getItem('vehicleDetails')
        let vehicleData= JSON.parse(vehicleDetails);
        if((this.tempIndex>this.sequenceLength)||(this.tempIndex<=0)){
          this.$fire({
                text: "Can't Change Sequence",
                type: "error",
                timer: 30000,
              });
              this.cancelEdit();
        }else{
          if (this.tempIndex !== null) { 
            for(let i=0;i<vehicleData[index].only_loads.length;i++){    
              if(this.tempIndex==vehicleData[index].only_loads[i].sequenceno && unikey!=vehicleData[index].only_loads[i].unikey){
                vehicleData[index].only_loads[i].sequenceno=null;
              }
            }
            for(let i=0;i<vehicleData[index].only_loads.length;i++){    
              if(unikey==vehicleData[index].only_loads[i].unikey){
                vehicleData[index].only_loads[pincodeindex].sequenceno=this.tempIndex;
              }
              
            }
            vehicleData[index].editable_flag='yes'
            vehicleData[index].addremove_restrictflag='yes'
            this.vehicleAcceptedLoads = vehicleData;   
            localStorage.setItem('vehicleDetails', JSON.stringify(vehicleData));
            // this.sequenceIndex = null;
            // this.tempIndex = null;
          }
      }
    },
    cancelEdit() {
      this.sequenceIndex = null;
      this.tempIndex = null;
    },
    checkAll(){
      // alert('innn')
      this.isCheckAll = !this.isCheckAll;
        if(this.isCheckAll){ // Check all
          for (let key in this.pincodeWiseLoad) {
            this.checkedParentAWB.push(this.pincodeWiseLoad[key].parentawb)
            }
        }else{
            this.checkedParentAWB=[];
        }
    },
    checkRandomAWB(e,pincodeWiseLoad) {
        if (this.checkedParentAWB.length >=0) {
          if (e.target.checked==true){
            if(this.checkedParentAWB.length == pincodeWiseLoad.length){
              this.isCheckAll = true;
            }
          }else{
            if(this.checkedParentAWB.length == 0){
              this.isCheckAll = false;
            }else if(this.checkedParentAWB.length !== pincodeWiseLoad.length){
              this.isCheckAll = false;
            } 
          }
        }  
      },
    

      //collapsable Code

      toggleCollapse(index,item) {

        this.isCheckAllLoad = false;
        this.checkedAWB=[];
        // Toggle the collapse based on the current state
        this.activeCollapseRoute = this.activeCollapseRoute === index ? null : index;
        // Update localStorage
        localStorage.setItem("activeCollapseRoute", this.activeCollapseRoute);
      },
      vehicleDrawerClose(){

      },

      //New Devlopment ---------
      checkAllLoad(loads){
        this.isCheckAllLoad = !this.isCheckAllLoad;
        if(this.isCheckAllLoad){ // Check all
          for (let key of loads) {
            this.checkedAWB.push(key.parentawb);
            }
        }else{
            this.checkedAWB=[];
        }
      },
      checkRandomAWBNew(e, item) {
        if (this.checkedAWB.length >=0) {
          if (e.target.checked==true){
            if(this.checkedAWB.length == item.length){
              this.isCheckAllLoad = true;
            }
          }else{
            if(this.checkedAWB.length == 0){
              this.isCheckAllLoad = false;
            }else if(this.checkedAWB.length !== item.length){
              this.isCheckAllLoad = false;
            } 
          }
        }  
      },
     

      removeLoadFromListing(loads,vehicleIndex){
        let items; // Get the array of checked items (which are objects)
        
        let loadsArr=[];
           if(loads.length==this.checkedAWB.length){
             items=loads;
           }else{
            loadsArr = loads.filter(element => this.checkedAWB.includes(element.parentawb));
           }
           if(loads.length!=this.checkedAWB.length){
            items=loadsArr
           }

         let vehicleDetails = localStorage.getItem('vehicleDetails');
         let vehicleData = JSON.parse(vehicleDetails);

         let pendingLaodData = localStorage.getItem('pendingLoads');
         let pendingLoadInfo = JSON.parse(pendingLaodData);
      
         if(vehicleData[vehicleIndex].addremove_restrictflag=='yes'){
           this.$fire({
               text: `Sequence Changed Can't Remove Load`,
               type: "error",
               timer: 30000,
             });
             return false
       }else{
        // Process each item in the checkedParentAWB array
         items.forEach((item,index) => {
         
          //  let data=index
             // Assuming `data` is the index of the current item in the original array
             // this.pincodeWiseLoad.splice(data, 1); // Remove the item from pincodeWiseLoad

             let popItem = item; // Each item is already an object in checkedParentAWB
             pendingLoadInfo.push(popItem); // Add the item to the pendingLoads array
             this.pendingLaods = pendingLoadInfo;

             localStorage.setItem('pendingLoads', JSON.stringify(pendingLoadInfo));

           
             let all_Loads = vehicleData[vehicleIndex].loads;

             // Find and remove the item from the all_Loads array
             let indexToRemove = all_Loads.findIndex(obj => obj.loadid === popItem.loadid);
             if (indexToRemove !== -1) {
                 all_Loads.splice(indexToRemove, 1);
             }

             // Update the vehicle's loads in vehicleData
             vehicleData[vehicleIndex].loads = all_Loads;
            
             // Recalculate waypoints
             let waypoints = vehicleData[vehicleIndex].destination_sequence;
             this.waypoints = waypoints.map(waypoint => ({
                 "lat": parseFloat(waypoint.latlong.x),
                 "lng": parseFloat(waypoint.latlong.y),
                 "pincode": waypoint.pincode
             }));

             localStorage.setItem('vehicleDetails', JSON.stringify(vehicleData));
         });
        
          this.isCheckAllLoad = false;
         this.addOrRemoveLoadsFromListing(vehicleIndex);
       }
      },
      addOrRemoveLoadsFromListing(index){
        document.getElementById("overlay").style.display = "block";
        let vehicleDetails=localStorage.getItem('vehicleDetails')
        let vehicleData= JSON.parse(vehicleDetails);
       
        let removeAddObj=vehicleData[index];
        
        this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/addOrRemoveLoadsAndSequelizepro145`, removeAddObj).then(result => {
          
          document.getElementById("overlay").style.display = "none";
          if (result.body.returnmsg === "Successful") {
          
            vehicleData[index]=result.body.returnvalue[0];
            
            this.vehicleAcceptedLoads = vehicleData;
            this.dest_pincode=vehicleData[index].destination_sequence;
            localStorage.setItem('destination_sequence',JSON.stringify(this.dest_pincode));
        
           let waypoints = vehicleData[index].destination_sequence;
          
            this.waypoints=waypoints.map(item=>({
              "lat": parseFloat(item.latlong.x),
              "lng": parseFloat(item.latlong.y),
              "pincode":item.pincode
            }))
            
            localStorage.setItem('vehicleDetails', JSON.stringify(vehicleData)); 
            this.totalvehiclelist= this.vehicleAcceptedLoads.length;
            this.checkedAWB=[];
            this.isCheckAll = false;
          } else {
            this.available_vehiclelist = [];
            this.pendingLaods = [];
            this.totalvehiclelist = 0;
            this.$fire({
              text: result.body.returnvalue,
              type: "error",
              timer: 30000,
            });
          }
          
        })

      },
      rowClass(item, type) {
        if(item){
          if(item.sequenceno==null){
            return 'table-danger'
          }
        }
      },

},
    
  };
</script>
<style scoped>
.custom-source-marker-container {
  position: absolute;
  z-index: 999; /* Adjust the z-index value to ensure it's above the DirectionsRenderer markers */
  top: 0; /* Adjust positioning as needed */
  left: 0; /* Adjust positioning as needed */
}
  .routetable th,
  td,th {
    text-align: center;
  }

  .route-border {
    border-bottom: 1px solid #c9bebe;
    margin: 30px 0px 20px 0px;
  }

  #overlay {
    position: fixed;
    /* Sit on top of the page content */
    /*display: none;*/
    /* Hidden by default */
    width: 100%;
    /* Full width (cover the whole page) */
    height: 100%;
    /* Full height (cover the whole page) */
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    /* Black background with opacity */
    z-index: 9999;
    /* Specify a stack order in case you're using a different order for other elements */
    cursor: pointer;
    /* Add a pointer on hover */
  }

  .loader {
    position: fixed;
    ;
    border: 5px solid #f3f3f3;
    border-radius: 50%;
    border-top: 5px solid #3498db;
    width: 50px;
    height: 50px;
    left: 50%;
    top: 50%;
    -webkit-animation: spin 2s linear infinite;
    /* Safari */
    animation: spin 2s linear infinite;
  }

  .loading {
    position: relative;
    width: 50px;
    height: 50px;
    left: 50%;
    top: 56%;
  }
  .customMarker{
    position: absolute;
    left: 0px;
    top: 0px;
    z-index: -1;
  }

  /* Safari */
  @-webkit-keyframes spin {
    0% {
      -webkit-transform: rotate(0deg);
    }

    100% {
      -webkit-transform: rotate(360deg);
    }
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }

    100% {
      transform: rotate(360deg);
    }
  }
  .dot{
    margin: 5px;
  }
  .red-dot {
  width: 20px;
  height: 20px;
  background-color: red;
  border-radius: 50%;
  display: inline-block;
  border: 2px black solid;
}
.green-dot {
  width: 20px;
  height: 20px;
  background-color: green;
  border-radius: 50%;
  display: inline-block;
  border: 2px black solid;
}
.yellow-dot {
  width: 20px;
  height: 20px;
  background-color: yellow;
  border-radius: 50%;
  display: inline-block;
  border: 2px black solid;
}
.modal {
  display: block;
  position: fixed;
  z-index: 1;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgba(0, 0, 0, 0.5);
}

.modal-content {
  background-color: #fefefe;
  margin: 15% auto;
  padding: 20px;
  border: 1px solid #888;
  width: 80%;
}

.close {
  color: #aaaaaa;
  float: right;
  font-size: 28px;
  font-weight: bold;
}

.close:hover,
.close:focus {
  color: #000;
  text-decoration: none;
  cursor: pointer;
}
.highlight-row {
  background-color: rgba(248, 72, 72, 0.699) !important ;
}
.bordered-col {
    border: 1px solid #ddd; /* Light grey border */
    /* background-color: white; White background */
    padding: 8px; /* Optional: add some padding */
  }
</style>